<template>
  <div class="setComponent">
    <!-- 表单 -->
    <div class="wrap-form">
      <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="180px" class="form-setting float-l form-setting-resrt">
        <el-form-item :label="$i18n.t('wm_lang_cd043c')" prop="origPassword">
          <el-input type="password" v-model="ruleForm.origPassword" show-password></el-input>
        </el-form-item>
        <el-form-item :label="$i18n.t('wm_lang_72d55e')" prop="pass">
          <el-input type="password" v-model="ruleForm.pass" autocomplete="off" show-password></el-input>
        </el-form-item>
        <el-form-item :label="$i18n.t('wm_lang_670d63')" prop="checkPass">
          <el-input type="password" v-model="ruleForm.checkPass" autocomplete="off" show-password></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')">{{$t("wm_lang_html_be5fbb")}}</el-button>
          <el-button @click="resetForm('ruleForm')">{{$t("wm_lang_html_625fb2")}}</el-button>
        </el-form-item>
      </el-form>
      <div class="note-box c_blue">
        <p v-if="pwdWeakRule.pwdClassify">1.{{$t("wm_lang_html_a72631")}}{{pwdWeakRule.pwdClassifyCount}}{{$t("wm_lang_html_918be6")}}</p>
        <p v-if="pwdWeakRule.pwdLen">2.{{$t("wm_lang_html_773926")}}{{pwdWeakRule.minPwdLen}}{{$t("wm_lang_html_40ff1a")}}20{{$t("wm_lang_html_cf10dc")}}</p>
        <p v-if="pwdWeakRule.pwdDiffOriginal">3.{{$t("wm_lang_html_2161fa")}}</p>
        <p v-if="pwdWeakRule.pwdIncDomainUser">4.{{$t("wm_lang_html_390209")}}</p>
        <p v-if="pwdWeakRule.pwdWeakForbidden">5.{{$t("wm_lang_html_cc4637")}}12345678{{$t("wm_lang_html_11ccee")}}</p>
        <p v-if="pwdWeakRule.pwdDiscontinuity">6.{{$t("wm_lang_html_600565")}}</p>
      </div>
    </div>
    <br><br>
  </div>
</template>

<script>
  import xmail from '@/api/api';
  import storeLocal from 'store';
  import { rsaEncrypt } from '@/utils/utils';
  export default {
    name: 'changePassword',
    data() {
      let checkOrigPassword = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.$i18n.t('wm_lang_9c19a4')));
        } else {
          //
          callback();
        }
      };
      let validatePass = (rule, value, callback) => {
        if(value.indexOf(' ') !== -1) {
          callback(new Error(this.$i18n.t('wm_lang_7650a1')));
        }
        if(value === this.ruleForm.origPassword) {
          callback(new Error(this.$i18n.t('wm_lang_1bb474')));
        }
        if (value === '') {
          callback(new Error(this.$i18n.t('wm_lang_e39ffe')));
        } else {
          if (this.ruleForm.checkPass !== '') {
            this.$refs.ruleForm.validateField('checkPass');
          }
          let self = this;
          (function (api, enums, pms) {
            let pm = {password: rsaEncrypt(value)};
            api.Account.detectPassword(pm, function (res) {
              if(res.data.code === 0) {
                if(!res.data.data.isAccordRule) {
                  callback(new Error(self.$i18n.t('wm_lang_62a7e4')));
                } else {
                  callback();
                }
              }
            })
          })(xmail.api, xmail.enums, xmail.pms);
          // callback();
        }
      };
      let validatePass2 = (rule, value, callback) => {
        if(value.indexOf(' ') !== -1) {
          callback(new Error(this.$i18n.t('wm_lang_7650a1')));
        }
        if (value === '') {
          callback(new Error(this.$i18n.t('wm_lang_a24ab0')));
        } else if (value !== this.ruleForm.pass) {
          callback(new Error(this.$i18n.t('wm_lang_f0d640')+'!'));
        } else {
          callback();
        }
      };
      return {
        ruleForm: {
          pass: '',
          checkPass: '',
          origPassword: ''
        },
        rules: {
          pass: [
            { validator: validatePass, trigger: 'blur' }
          ],
          checkPass: [
            { validator: validatePass2, trigger: 'blur' }
          ],
          origPassword: [
            { validator: checkOrigPassword, trigger: 'blur' }
          ]
        },
        localConfigSetting: {},
        pwdWeakRule: {}
      };
    },
    mounted() {
      this.localConfigSetting = storeLocal.get('Pwm-configSetting');
      this.pwdWeakRule = this.localConfigSetting.pwdWeakRule;
    },
    methods: {
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let self = this;
            (function (api, enums, pms) {
              let pm = pms.Account.updatePasswordParamBuilder();
              pm.oldPassword = rsaEncrypt(self.ruleForm.origPassword);
              pm.newPassword =  rsaEncrypt(self.ruleForm.pass);
              api.Account.updatePassword(pm, function (res) {
                console.log(res)
                if(res.data.code === 0) {
                  self.$message({
                    type: 'success',
                    message: self.$i18n.t('wm_lang_f4578a')
                  });
                  self.ruleForm.pass = '';
                  self.ruleForm.checkPass = '';
                  self.ruleForm.origPassword = '';
                  storeLocal.remove('Pwm-Islogin');
                  let configSetting = storeLocal.get('Pwm-configSetting');
                  let logoutUrl = configSetting.displaySetting.logoutUrl;
                  if(logoutUrl) {
                    location.href = logoutUrl;
                  } else {
                    self.$router.push({ path: '/' });
                  }
                } else {
                  /*let eMsg = self.$GetErrorMsg(res.data.code);
                  self.$message({
                    type: 'error',
                    message: eMsg
                  });*/
                }
              })
            })(xmail.api, xmail.enums, xmail.pms);
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      resetForm(formName) {
        // this.$refs[formName].resetFields();
        this.$router.push({name: 'accountSecurity'});
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .setComponent{padding:10px;overflow: hidden;}
 .setComponent .title .el-divider--horizontal{margin:10px 0;}
 .note-box{ margin: 20px 0 0 56px;float:left;line-height:24px;width:600px;}
 .form-setting-resrt{width:450px;}
</style>



// WEBPACK FOOTER //
// src/components/views/setBox/changePassword.vue